var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","fill":"currentColor","viewBox":"0 0 12 12"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12ZM1.8 5.867l1.273-1.273 2.121 2.121 3.394-3.394 1.273 1.273-4.667 4.667L1.8 5.867Z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }